module.exports = __webpack_public_path__ + "media/莫文蔚（Karen Mok） - 這世界那麼多人（《我要我們在一起》電影主題曲）♫【無損高音質｜CC歌詞字幕】（Music 2021）.b2729443.mp3";